
export const Problem = ""
export const Symptom = "#symptom"
export const Modifier = "#modifier"
export const Kbs = "#kbs"
export const Intervention = "#intervention"
export const Confirm = "#confirm"
